<template>
  <div class="con">
    <Nav/>
    <img src="../assets/img/bannercontactus.jpg" alt="" class="banner">
    <div class="banner-p">
      <div class="wa">{{$t("Contact.bannerT2")}}</div>
      <div class="xian" v-if="$t('language.name') == 'En'"></div>
    </div>
    <h4 class="cq">{{$t("Contact.h4")}}  &nbsp;<span v-if="$t('language.name') == 'En'">/</span></h4>
    <div class="map1">
      <img src="../assets/img/con-bg.png" alt="" class="banner1">
      <img src="../assets/img/con-bg2.png" alt="" class="banner2">
      <img src="../assets/img/con-bg3.png" alt="" class="banner3">
      <ul class="cq-weizi">
        <li>
          <img src="../assets/img/phone.png" alt="" class="cq-icon">
          <p class="title">{{$t("Contact.tel")}}</p>
          <p class="text">+86 23 62735888</p>
        </li>
        <li class="w330">
          <img src="../assets/img/mail.png" alt="" class="cq-icon">
          <p class="title">{{$t("Contact.Email")}}</p>
          <p class="text email">contact@geelyfintech.com </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Nav from './nav'
import HomeIcon from '@/assets/img/map-icon.png'; 
export default {
  name: 'Contact',
  components: {
    Nav
  },
  mounted() {
    // this.handler()
  },
  data() {
    return {
      center: { lng: 0, lat: 0 }, //经纬度
      zoom: 17, //地图展示级别
      center2: { lng: 0, lat: 0 }, //经纬度
      zoom2: 17, //地图展示级别
    }
  },
  methods: {
    handler({ BMap, map }) {
      this.center.lng = 106.496737;
      this.center.lat = 29.632057;
      this.zoom = this.zoom;
    },
    handler2({ BMap, map }) {
      this.center2.lng = 121.515199;
      this.center2.lat = 31.239317;
      this.zoom2 = this.zoom2;
    }
  }
}
</script>

<style scoped lang="less">
.con {
  width: 100%;
  height: 100%;
  background: #F8F8F8;
  min-width: 1260px;
  padding-bottom: 60px;
  position: relative; 
  .map1 {
    width: 1000px;
    margin: 0 auto;
    margin-top: 20px;
    overflow: hidden;
    .banner1 {
      width: 1000px;
      height: 550px;
      margin-bottom: 10px;
      float: left;
    }
    .banner2 {
      width: 540px;
      height: 270px;
      float: left;
      margin-right: 10px;
    }
    .banner3 {
      width: 450px;
      height: 320px;
      float: right;
    }
  }
  .banner {
    width: 100%;
    height: 387px;
    display: block;
  }
  .banner-p {
    width: 1260px;
    height: 70px;
    position: absolute;
    top: 158px;
    left: 50%;
    margin-left: -630px;
    padding-left: 80px;
    box-sizing: border-box;
  }
  .wa {
    float: left;
    font-style: normal;
    font-weight: 500;
    font-size: 44px;
    line-height: 70px;
    color: #fff;
  }
  .xian {
    float: left;
    background: #fff;
    width: 90px;
    height: 2px;
    margin-top: 34px;
    margin-left: 50px;
  }
  .cq {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    color: #242A32;
    display: block;
    width: 1000px;
    margin: 0 auto;
    margin-top: 80px;
  }
  .cq-weizi {
    width: 540px;
    height: 122px;
    background: #fff;
    float: left;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.05);
    position: relative;
    margin-top: 10px;
    li {
      float: left;
      width: 220px;
      padding-left: 65px;
      position: relative;
      overflow: hidden;
      box-sizing: border-box;
      img {
        position: absolute;
        width: 25px;
        height: 25px;
        left: 30px;
        top: 30px;
      }
      .title {
        line-height: 25px;
        margin-top: 30px;
        margin-bottom: 12px;
        color: #3D434D;;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
      }
      .text {
        width: 100%;
        font-size: 14px;
        line-height: 24px;
        color: #76808E;
      }
      .email {
        color: #2284F6;
      }
    }
    .w330 {
      width: 300px;
    }
  }
  .cq-weizi::before {
    position: absolute;
    width: 1px;
    height: 60px;
    content: "";
    background: #F6F6F6;
    left: 212px;
    top: 32px;
    z-index: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contact.vue